import {
    Button, Card, CircularProgress, Dialog, DialogContent, DialogTitle,
    Divider, FormGroup, FormLabel, Grid, IconButton, Switch, TextField
} from "@mui/material";
import { IconX } from "@tabler/icons-react";
// import VWDropdown from "components/dropdown";
import { removeEmptyKeys } from "helper/encodeData";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { ErrorAlert } from "ui-component/custom-components/alertMessage";
import { Required } from "ui-component/custom-components/mandatory";
import {
    customerEdit,
    customerEditErrorClear,
    // getUsersOption
} from "store/app/customer-management/actions";

const styles = {
    "& input::-webkit-outer-spin-button, & input::-webkit-inner-spin-button": {
        display: "none",
    },
    "& input[type=number]": {
        MozAppearance: "textfield",
    },
}

const EditCustomer = (props) => {

    const { open, errorMessage, onClose, isPending, customerDetails } = props;

    const [customerData, setCustomerData] = useState();
    const [isActive, setIsActive] = useState();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (customerDetails) {
            setIsActive(customerDetails?.isActive);
            setCustomerData({ ...customerDetails });
            // const { customerManagedByUserList } = customerDetails;
            // const assignedUserIds = customerManagedByUserList?.map((user) => user.userId);
            // const assignedUsers = customerManagedByUserList?.map((user) => {
            //     return {
            //         label: `${user.userName} | ${user.userEmail}`,
            //         value: user.userId
            //     }
            // })
            // setSelectedUsers(assignedUsers);
        }
        setErrors({});
        props.customerEditErrorClear();
    }, [open])

    //--------------------User---------------------------
    // const [usersOptions, setUsersOptions] = useState([]);
    // const [selectedUsers, setSelectedUsers] = useState([]);

    // const loadUsersOption = (filter) => {
    //     return props.getUsersOption(filter)
    // }

    const validateOnchange = (e) => {
        const { name, value } = e.target;
        let result = {};

        if (name === 'email') {
            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            result = {
                isValid: !emailRegex.test(value),
                message: 'Enter valid email address',
            };
        }
        if (name === 'mobileNumber') {
            const contactNumberRegex = /^\d{10}$/;
            result = {
                isValid: !contactNumberRegex.test(value),
                message: 'Enter valid mobile number',
            };
        }

        setCustomerData({
            ...customerData,
            [name]: value
        })
        setErrors({
            ...errors,
            [name]: result.isValid ? result.message : null,
        })
    }

    // const handleAssignedUsersSelect = (option, name) => {
    //     const optionArray = option?.map(field => field.value);
    //     setCustomerData({
    //         ...customerData,
    //         [name]: optionArray
    //     })
    //     setSelectedUsers(option);
    // }

    const handleActiveStatusChange = () => {
        setIsActive(!isActive);
        setCustomerData({
            ...customerData,
            isActive: !isActive
        })
    };

    const handleChangePassword = (e) => {
        e.preventDefault();

        const { customerName, email, mobileNumber } = customerData || {};
        const currentErrors = {};

        if (!customerName && !customerName?.trim()) {
            currentErrors.customerName = 'Customer name is required';
        }
        if (!email && !email?.trim()) {
            currentErrors.email = 'Email address is required';
        }
        if (errors && errors.email) {
            currentErrors.email = 'Enter valid email address';
        }
        if (!mobileNumber && !mobileNumber?.trim()) {
            currentErrors.mobileNumber = 'Mobile number is required';
        }
        if (errors && errors.mobileNumber) {
            currentErrors.mobileNumber = 'Enter valid mobile number';
        }
        setErrors(currentErrors);

        if (Object.keys(currentErrors).length === 0) {
            props.customerEdit(customerData);
        }
    }

    const validateClose = (e, reason) => {
        if (reason !== 'backdropClick') {
            onClose();
        }
    }

    return (
        <>
            <Dialog open={open} maxWidth={'xs'} fullWidth onClose={validateClose}>
                {open && (
                    <>
                        <Card sx={{ overflow: 'auto' }} >
                            <DialogTitle sx={{ display: 'flex', justifyContent: 'space-between', alignItems: "center", pt: 0, pb: 0 }}>
                                Edit Customer
                                <IconButton
                                    aria-label="close"
                                    onClick={onClose}
                                >
                                    <IconX />
                                </IconButton>
                            </DialogTitle>
                            <Divider />
                            <DialogContent>
                                {errorMessage && <ErrorAlert content={errorMessage} />}
                                <form>
                                    <Grid container rowGap={4} marginTop={2}>
                                        <Grid container rowGap={3} justifyContent={'center'} direction={'column'}>
                                            <Grid item >
                                                <TextField
                                                    label={<div >Customer Name <Required /></div>}
                                                    autoFocus
                                                    fullWidth
                                                    size="small"
                                                    name='customerName'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={customerData?.customerName}
                                                    error={errors?.customerName}
                                                    helperText={errors?.customerName}
                                                />
                                            </Grid>
                                            <Grid item >
                                                <TextField
                                                    label={<>Email Address<Required /></>}
                                                    fullWidth
                                                    size="small"
                                                    name='email'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={customerData?.email}
                                                    error={errors?.email}
                                                    helperText={errors?.email}
                                                />
                                            </Grid>
                                            <Grid item>
                                                <TextField
                                                    label={<>Mobile Number <Required /></>}
                                                    sx={styles}
                                                    fullWidth
                                                    size="small"
                                                    name='mobileNumber'
                                                    type='number'
                                                    onKeyDown={
                                                        (e) => ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
                                                    }
                                                    onChange={validateOnchange}
                                                    value={customerData?.mobileNumber}
                                                    error={errors?.mobileNumber}
                                                    helperText={errors?.mobileNumber}
                                                />
                                            </Grid>
                                            {/* <Grid item sx={{ width: "100%" }}>
                                                <VWDropdown
                                                    label="Assigned Users"
                                                    name="userIds"
                                                    multiple={true}
                                                    disablePortal={true}
                                                    getOptions={loadUsersOption}
                                                    onSelect={handleAssignedUsersSelect}
                                                    isOptionEqualToValue={(option, value) => option?.value === value?.value}
                                                    selectedOption={selectedUsers || []}
                                                    options={usersOptions}
                                                    setOptions={setUsersOptions}
                                                />
                                            </Grid> */}
                                            <Grid item >
                                                <TextField
                                                    label={<>Address</>}
                                                    fullWidth
                                                    multiline
                                                    rows={2}
                                                    size="small"
                                                    name='address'
                                                    type='text'
                                                    onChange={validateOnchange}
                                                    value={customerData?.address || ""}
                                                    error={errors?.address}
                                                    helperText={errors?.address}
                                                />
                                            </Grid>
                                            <Grid item >
                                                <FormGroup>
                                                    <FormLabel sx={{ fontWeight: 'bold', color: 'black' }}>Customer Status</FormLabel>
                                                    <Grid container alignItems={'center'}>
                                                        <Grid item sx={{ color: 'black' }}>Inactive</Grid>
                                                        <Grid item>
                                                            <Switch
                                                                color='success'
                                                                onChange={handleActiveStatusChange}
                                                                checked={customerData?.isActive}
                                                            />
                                                        </Grid>
                                                        <Grid item sx={{ color: 'black' }}>Active</Grid>
                                                    </Grid>
                                                </FormGroup>
                                            </Grid>
                                        </Grid>
                                        <Grid container justifyContent={'right'}>
                                            <Button
                                                variant="contained"
                                                onClick={handleChangePassword}
                                                size="small"
                                                color="primary"
                                                disabled={isPending || Object.keys(removeEmptyKeys(errors))?.length > 0}
                                            >
                                                {isPending ? <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                    <CircularProgress size={'20px'} color='inherit' />
                                                    Loading...
                                                </div>
                                                    : 'Submit'
                                                }
                                            </Button>
                                            <Button
                                                variant="contained"
                                                onClick={onClose}
                                                sx={{ ml: 2 }}
                                                color='error'
                                                size="small"
                                            >
                                                Close
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </form>
                            </DialogContent>
                        </Card>
                    </>
                )
                }

            </Dialog >

        </>
    )
}

const mapStateToProps = (state) => ({
    isPending: state.customers.isCustomerEditPending,
    errorMessage: state.customers.customerEditErrorMessage,
})
const mapDispatchToProps = (dispatch) => ({
    customerEdit: (formData) => dispatch(customerEdit(formData)),
    customerEditErrorClear: () => dispatch(customerEditErrorClear()),
    //--------------------User---------------------------
    // getUsersOption: (filter) => dispatch(getUsersOption(filter)),
})

export default connect(mapStateToProps, mapDispatchToProps)(EditCustomer);